import { NgModule } from '@angular/core';
import { S142gS142m01Component } from './s142g-s142m01.component';
import { SharedModule } from './../../shared.module';

@NgModule({
    imports: [SharedModule],
    exports: [],
    declarations: [S142gS142m01Component]
})
export class S142gModule { }

